import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ocoPost } from 'helpers/googleTagManager';

const GoogleTagWidget = ({ children }) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const utm_source = searchParams.get('utm_source');
  const utm_medium = searchParams.get('utm_medium');
  const utm_campaign = searchParams.get('utm_campaign');
  const utm_content = searchParams.get('utm_content');
  const kw = searchParams.get('kw');
  const mtype = searchParams.get('mtype');
  const network = searchParams.get('network');
  const device = searchParams.get('device');
  const kwid = searchParams.get('kwid');
  const gclid = searchParams.get('gclid');
  const model = searchParams.get('model');
  const position = searchParams.get('position');
  const test = searchParams.get('test');

  useEffect(() => {
    // Initialize Google Tag Manager (runs once on mount)
    const gtmId = process.env.REACT_APP_GTM_ID;

    if (gtmId && typeof window !== 'undefined') {
      // Avoid duplicate injection
      const existingScript = document.getElementById('gtm-script');
      if (!existingScript) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'gtm.start': new Date().getTime(),
          event: 'gtm.js',
        });

        const script = document.createElement('script');
        script.async = true;
        script.id = 'gtm-script';
        script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(
          gtmId
        )}`;
        document.head.appendChild(script);
      }
    }

    // let oco_profile_id = localStorage.getItem('oco_profile_id');
    // if (!oco_profile_id) {
    //   axios.post(osoPatchUrl).then((res) => {
    //     if (res.data.oco_profile_id) {
    //       oco_profile_id = res.data.oco_profile_id;
    //       localStorage.setItem('oco_profile_id', oco_profile_id);
    //     }
    //   });
    // }
    if (utm_source) {
      const formJsonModel = {
        utm_source,
        utm_medium,
        utm_campaign,
        utm_content,
        kw,
        mtype,
        network,
        device,
        kwid,
        gclid,
        model,
        position,
        test,
      };
      ocoPost(formJsonModel);
      // ocoPatch(formJsonModel, oco_profile_id);
    }
  }, []);

  // Track SPA page views
  useEffect(() => {
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        event: 'pageview',
        page_path: `${location.pathname}${location.search}`,
      });
    }
  }, [location.pathname, location.search]);

  return <div>{children}</div>;
};

export default GoogleTagWidget;
